import { useNewLeadNotifier } from "@/hooks/call-center/useNewLeadNotification";

/**
 * This component has no UI — it only mounts the global socket
 * listener that triggers new-lead toast notifications.
 * Place it inside both SnackbarProvider and SocketProvider.
 */
const GlobalNotificationListener = () => {
    useNewLeadNotifier();
    return null;
};

export default GlobalNotificationListener;